module.exports = __webpack_public_path__ + "img/coupon.15526db7.png";